import { ChainId } from '@ui/types/chain';
import { getContract, PublicClient, WalletClient } from 'viem';

import TradingConfigFacet from '../abis/TradingConfigFacet';
import { getContractAddress } from '../constants/address';

export const getTradingConfigFacet = ({
  chainId,
  publicClient,
  walletClient,
}: {
  publicClient: PublicClient;
  walletClient?: WalletClient;
  chainId: ChainId;
}) => {
  const address = getContractAddress('LeverUp', chainId);
  if (!address) throw new Error('Contract address not found');

  return getContract({
    abi: TradingConfigFacet,
    address,
    client: {
      public: publicClient,
      wallet: walletClient,
    },
  });
};
